
import React from 'react';
import { Button } from '@/components/ui/button';
import { FileCheck, Download } from 'lucide-react';

interface ActionButtonsProps {
  onHide: () => void;
}

export const ActionButtons = ({ onHide }: ActionButtonsProps) => {
  return (
    <div className="p-4 border-t flex justify-end gap-2 shrink-0 bg-background">
      <Button
        variant="outline"
        size="sm"
        onClick={onHide}
      >
        Close
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="gap-1"
      >
        <Download className="h-4 w-4 mr-1" />
        Export
      </Button>
      <Button
        variant="default"
        size="sm"
        className="gap-1"
      >
        <FileCheck className="h-4 w-4 mr-1" />
        View Full Report
      </Button>
    </div>
  );
};
